import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Text from "../Text/Text";
import { Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {
  hideTermAndCondition,
  showPrivacyPolicyModal,
} from "../../store/login/action";
import PrivacyPolicy from "./PrivacyPolicy";
import { getTermsOfUsesEditorSelector } from "../../store/profile/selector";
import { getTermsOfUsesEditorDataAction } from "../../store/profile/action";
import { useParams } from "react-router-dom";

const useStyles = makeStyles({
  heading: {
    fontWeight: 700,
  },
  bgColor: {
    backgroundColor: "#20419a",
    color: "white",
  },
});

const TermAndCondition = (props) => {
  const loginStore = useSelector((state) => state["loginState"]);
  const TermsAndUseEditorData = useSelector(getTermsOfUsesEditorSelector);
  const { customer } = useParams();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (customer) {
        dispatch(getTermsOfUsesEditorDataAction(customer));
    }
  }, [customer]);

  const handleClose = () => {
    dispatch(hideTermAndCondition());
  };
  const handlePrivacy = () => {
    dispatch(showPrivacyPolicyModal());
  };
  const classes = useStyles();
  return (
    <>
      <Dialog
        open={loginStore && loginStore.termAndConditionModalYN}
        maxWidth="md"
        fullWidth
      >
        <Grid container xs={12} md={12} spacing={2}>
          <DialogContent className="modalroot">
            <Grid item xs={12} md={12}>
              <Text variant="h5" className={classes.heading}>
                Terms and conditions
              </Text>
              <Divider />
            </Grid>
            <Grid item xs={12} md={12} className="textPadding">
              {TermsAndUseEditorData && TermsAndUseEditorData.text != "" ? (
                 <div
                 className="ql-editor"
                 style={{ color: "black" }}
                 dangerouslySetInnerHTML={{ __html: TermsAndUseEditorData }}
               />
              ) : (
               ""
              )}
            </Grid>
          </DialogContent>
        </Grid>
        <DialogActions>
          <Button
            onClick={handleClose}
             color="primary"
            variant="contained"
          >
            ok
          </Button>
        </DialogActions>
        <PrivacyPolicy />
      </Dialog>
    </>
  );
};
export default TermAndCondition;
